// vue-i18n config options
// @ts-ignore --- defineI18nConfig is auto-imported
export default defineI18nConfig(nuxt => ({
  legacy: false,
  // availableLocales: ['en', 'fr'],
  availableLocales: ['en'],
  locale: "en",
  fallbackLocale: "en",
}))